import LedgerForm from '@/components/forms/master/account/ledger/LedgerForm';
import GlobalFormModal from '@/utils/modal/GlobalFormModal';
import CustomSelect from '@/utils/search/Search';
import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Tooltip,
} from 'antd';
import { useEffect, useRef, useState } from 'react';
import { NewNepaliDatePicker } from '@/common/customNepaliDatePicker';
import {
  getAdFromBS,
  getBsFromAD,
  getTodayDate,
  getTodayDateAd,
} from '@/utils/helpers/getTodayDate';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ConfirmModal } from './modals/ConfirmModal';
import RadioButtonGroup from '@/common/ant-components/RadioGroupReport';
import { useNavigationHistory } from '@/common/navigation-history';
import { useTransactionContext } from '@/context/TransactionContext';
import { returnLinks } from '@/common/navigation-history/data';
import { exclude } from '@/utils/routerPath/data';
import { BACK_ROUTES_PATH } from '@/utils/routerPath/route-path';
import {
  BILL_FORMAT_TYPES,
  getBillFormatList,
} from '@/utils/transaction/billFormat';
import dayjs from 'dayjs';
import useAppData from '@/hooks/useAppData';
import {
  ShowAllData,
  useGetApiListNoToast,
  useMutateGetApi,
} from '@/apiError/apiShow';
import { set } from 'lodash';
import { AntButton } from '@/common/ant-components/AntButton';
import {
  ClearOutlined,
  FilterOutlined,
  PlusCircleOutlined,
  PlusCircleTwoTone,
  PlusOutlined,
} from '@ant-design/icons';
import DraggableModal from '@/common/ant-components/DraggableModal';
import SalesType from '@/utils/helper/salesType';

const DynamicTransactionHeader = ({
  hanldeInputData,
  showPartyList,
  refreshTable,
  from,
  form,
  agentList,
  isFromQuickPurchase = false,
  selectRefs,
  selectRef,
  agentRef,
  selectedData,
  tableData = [],
  noPadding = false,
  isFromStockAdjustment = false,
  partyLoading = false,
  onPartyPopupScroll,
  onPartySearch,
  onPartyOpenChange,
  onAgentPopupScroll,
  onAgentSearch,
  onAgentOpenChange,
  agentLoading = false,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [filterVisible, setFilterVisible] = useState(false);

  const { data: subGroupData } = useGetApiListNoToast(
    `account/inventory/sub-groups/`,
  );

  const { data: groupData } = useGetApiListNoToast(`account/inventory/groups/`);

  // const res = await ShowAllData.showDetails('account/inventory/groups/');

  const isOrder = from === 'order';
  const isStock = from === 'stock';

  const isSales = from === 'salesagent';

  const {
    setSelectedData,
    groupIds,
    setGroupIds,
    categoryIds,
    setCategoryIds,
    billFormatList,
    setBillFormatList,
    billFormatId,
    setBillFormatId,
  } = useTransactionContext();

  const { mutateAsync: getBillData } = useMutateGetApi();

  const { id: editReferenceId } = useParams();

  const [yesNo, setYesNo] = useState(false);
  const noRef = useRef();
  const yesRef = useRef();

  const navigate = useNavigate();
  const location = useLocation();


  const formInstance = Form.useFormInstance() || form;

  const isSalesCreate = location.pathname.startsWith('/sales/create/');

  const isSalesOrderCreate = /^\/sales\/order\/create(\/|$)/.test(
    location.pathname,
  );

  const isPurchaseCreate = /^\/purchase\/create(\/|$)/.test(location.pathname);

  const issueCreateType = location.pathname.match(
    /^\/issue\/([^/]+)\/create(\/|$)/,
  )?.[1];

  const receiveCreateType = location.pathname.match(
    /^\/receive\/([^/]+)\/create(\/|$)/,
  )?.[1];

  const formatTransactionType = isSalesCreate
    ? BILL_FORMAT_TYPES.SALES
    : isSalesOrderCreate
      ? BILL_FORMAT_TYPES.SALES_ORDER
      : isPurchaseCreate
        ? BILL_FORMAT_TYPES.PURCHASE
        : issueCreateType
          ? `issue_${issueCreateType}`
          : receiveCreateType
            ? `receive_${receiveCreateType}`
            : null;

  const hasBillFormat = Boolean(formatTransactionType);

  const storeBillNumberBase = (() => {
    const p = location.pathname;
    if (/\/sales\/quotation\/(create|edit)/.test(p)) {
      return '/transaction/quotation/latest-bill-number/';
    }
    if (/^\/sales\/order\/(create|edit)(\/|$)/.test(p)) {
      return '/transaction/sales-order/latest-bill-number/';
    }
    if (/^\/sales\/(create|edit)(\/|$)/.test(p)) {
      return '/transaction/sales/latest-bill-number/';
    }
    if (/^\/purchase\/(create|edit)(\/|$)/.test(p)) {
      return '/transaction/purchases/latest-bill-number/';
    }
    const issueType = p.match(/^\/issue\/([^/]+)\/(create|edit)(\/|$)/)?.[1];
    if (issueType) {
      return `/transaction/issues/${issueType}/latest-bill-number/`;
    }
    const receiveType = p.match(
      /^\/receive\/([^/]+)\/(create|edit)(\/|$)/,
    )?.[1];
    if (receiveType) {
      return `/transaction/receives/${receiveType}/latest-bill-number/`;
    }
    return null;
  })();

  const isSalesQuotation =
    location.pathname.includes('/sales/quotation/create/') ||
    location.pathname.includes('/transaction/sales/quotation/edit/');

  const isSalesOrder =
    from === 'quickpurchase'
      ? false
      : location.pathname.includes('/sales/order/create/') ||
        location.pathname.includes('/sales/order/edit/');
  const formD = Form.useFormInstance();

  const pathname = location?.pathname;

  const state = location?.state || null;

  const isExcluded = exclude?.some((path) =>
    location?.pathname?.startsWith(path),
  );

  const isRedirectPath = BACK_ROUTES_PATH?.find(
    (item) => item?.route === pathname || pathname?.startsWith(item.route),
  )?.route_to_redirect;

  const history = useNavigationHistory();

  const { ledgerDetails, hiddenValueChange, stockDetails, setLedgerDetails } =
    useTransactionContext();

  const stateData = ledgerDetails
    ? ledgerDetails
    : stockDetails?.code
      ? stockDetails
      : state;

  const target = isExcluded
    ? null
    : Array.isArray(history)
      ? [...history]
          .reverse()
          .find(
            (path, index) =>
              index === 1 &&
              returnLinks?.some((prefix) => path.startsWith(prefix)),
          )
      : null;

  const [isSalesAgent, setIsSalesAgent] = useState(false);

  const handleAddClick = () => {
    setIsSalesAgent(false);
    setIsModalVisible(true);
  };

  const handleAddClickSalesAgent = () => {
    setIsSalesAgent(true);
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const focusNode = (key) => {
    const inputInstance = formD?.getFieldInstance(key);
    if (inputInstance) {
      inputInstance?.focus({
        cursor: 'end',
      });
    }
  };

  useEffect(() => {
    focusNode('entryNumber');
  }, []);


  useEffect(() => {
    if (!hasBillFormat) return;
    formInstance?.setFieldsValue({ billFormat: billFormatId ?? null });
  }, [billFormatId, hasBillFormat]);

  const partyListArray =
    showPartyList?.map((partyName) => ({
      key: partyName.referenceId,
      value: partyName.referenceId,
      ledgerName: partyName.name,
      label: partyName.name,
    })) ?? [];

  const handleKeyDown = (e) => {
    if (e.code === 'Escape' && hiddenValueChange) {
      e.preventDefault();
      setTimeout(() => {
        noRef?.current?.focus();
      }, 100);
      setYesNo(true);
    } else if (!hiddenValueChange && e.code === 'Escape') {
      e.preventDefault();
      target
        ? navigate(target, {
            state: {
              ...stateData,
              from: state?.from
                ? state.from
                : isHistoryContainsSundry
                  ? 'sundry'
                  : null,
            },
          })
        : isRedirectPath
          ? navigate(isRedirectPath, {
              state: {
                ...stateData,
              },
            })
          : navigate(-1);
    }
  };

  const { app } = useAppData();


  const hasStores = app?.stores?.length > 1;

  const [dateType, setDateType] = useState(
    app?.dateType === 'bs' ? 'bs' : 'ad',
  );

  const handleRadio = (e) => {
    setDateType(e?.target?.value);
  };

  const nepaliDateRef = useRef(null);
  const deliveryDateNepaliRef = useRef(null);
  const orderDateNepaliRef = useRef(null);

  const orderDataAD = Form.useWatch('entryDate', form) || dayjs();

  // Order date in BS — used to keep the delivery date on/after the order date.
  const orderDataBs = Form.useWatch('entry_date_bs', form);

  // sales/create order date — the entry date must not fall behind it.
  const salesOrderDateAD = Form.useWatch('orderDate', form);
  const salesOrderDateBs = Form.useWatch('order_date_bs', form);

  return (
    <>
      <Row
        style={{
          paddingLeft: !noPadding ? '15px' : undefined,
          paddingRight: !noPadding ? '15px' : undefined,
        }}
        gutter={[16, 16]}
        justify="space-between"
      >
        {/* Left-aligned columns */}
        <ConfirmModal
          yesNo={yesNo}
          noRef={noRef}
          yesRef={yesRef}
          setYesNo={setYesNo}
        />
        <Col xs={24} md={12} lg={4}>
          <Form.Item
            label="Bill No"
            className="username"
            name={isFromQuickPurchase ? 'purchaseBillNumber' : 'billNumber'}
          >
            <Input
              disabled
              onKeyDown={(e) => {
                handleKeyDown(e);
              }}
              onChange={(e) => hanldeInputData('billNo', e.target.value)}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12} lg={4}>
          <Form.Item
            className="username"
            label="Reference No"
            name="entryNumber"
            rules={[{ required: false, message: '' }]}
          >
            <Input
              placeholder="Entry Number"
              onPressEnter={(e) => {
                e.preventDefault();
                const billFormatVisible = billFormatList?.length > 1 && hasBillFormat;
                if (billFormatVisible) {
                  focusNode('billFormat');
                  return;
                }
                if (dateType === 'ad') {
                  focusNode('entryDate');
                }
                if (dateType === 'bs') {
                  focusNode('entry_date_bs');
                  nepaliDateRef?.current?.focus();
                }
              }}
              onKeyDown={(e) => {
                if (e.code === 'ArrowRight') {
                  focusNode('entryDate');
                } else {
                  handleKeyDown(e);
                }
              }}
              onChange={(e) => hanldeInputData('entryNumber', e.target.value)}
              disabled={selectedData?.isCancel}
            />
          </Form.Item>
        </Col>

        {billFormatList?.length > 1 &&
          billFormatList?.length !== 0 &&
          hasBillFormat && (
            <Col xs={24} md={12} lg={4}>
              <Form.Item
                label="Bill Format"
                className="username"
                name={'billFormat'}
              >
                <Select
                  placeholder="Select Bill Format"
                  allowClear
                  options={billFormatList?.map((item) => ({
                    label: item?.billName || item?.billFormat,
                    value: item?.billFormatId,
                  }))}
                  disabled={selectedData?.isCancel}
                  onKeyDown={(e) => {
                    if (e.code === 'Escape') {
                      e.preventDefault();
                      handleKeyDown(e);
                    }
                    if (e.code === 'Enter' || e.code === 'NumpadEnter') {
                      // After Enter on the bill format, advance to date field
                      setTimeout(() => {
                        if (dateType === 'ad') {
                          focusNode('entryDate');
                        } else {
                          focusNode('entry_date_bs');
                          nepaliDateRef?.current?.focus();
                        }
                      }, 0);
                    }
                  }}
                  onChange={async (value) => {
                    setBillFormatId(value);
                    const storeId = selectedData?.storeId;
                    if (value && storeId) {
                      const response = await getBillData({
                        url: `${storeBillNumberBase}?storeId=${storeId}&billFormatId=${value}`,
                      });
                      hanldeInputData(
                        isFromQuickPurchase
                          ? 'purchaseBillNumber'
                          : 'billNumber',
                        response?.billNumber,
                      );
                    }
                    if (dateType === 'ad') {
                      focusNode('entryDate');
                    } else {
                      focusNode('entry_date_bs');
                      nepaliDateRef?.current?.focus();
                    }
                  }}
                />
              </Form.Item>
            </Col>
          )}
        {isSales && app.calculateOnPure && (
          <Col xs={24} md={12} lg={4}>
            <Form.Item
              name={'salesType'}
              label="Sales Type"
              className="username"
            >
              <Select
                options={SalesType}
                onChange={(value) => hanldeInputData('salesType', value)}
              />
            </Form.Item>
          </Col>
        )}
        <Col xs={24} md={12} lg={2} style={{ marginLeft: 'auto' }}>
          <RadioButtonGroup
            name="date_type"
            initialValue={dateType}
            onChange={handleRadio}
          />
        </Col>
        <Col
          xs={dateType === 'bs' ? 0 : 24}
          md={dateType === 'bs' ? 0 : 12}
          lg={dateType === 'bs' ? 0 : 4}
        >
          <Form.Item
            name="entryDate"
            label={from === 'order' ? 'Order Date' : 'Entry Date'}
            className="username"
            rules={[{ required: true, message: '' }]}
            hidden={dateType === 'bs'}
          >
            <DatePicker
              style={{ width: '100%' }}
              className="date-picker "
              format="YYYY-MM-DD"
              allowClear={false}
              onChange={(date) => {
                hanldeInputData('entryDate', date);
                setSelectedData((prev) => ({
                  ...prev,
                  entryDate: date,
                }));
                if (date) {
                  formD.setFieldsValue({
                    entry_date_bs: getBsFromAD(date),
                  });
                }
              }}
              onKeyDown={(e) => {
                if (e.code === 'Enter' || e.code === 'NumpadEnter') {
                  e.preventDefault();
                  if (isStock) {
                    selectRefs.current[0]?.current?.focus();
                  } else if (!isOrder) {
                    selectRef.current?.focus();
                  } else if (isOrder) {
                    focusNode('deliveryDate');
                  }
                }
                if (e.code === 'ArrowUp') {
                  e.preventDefault();
                  focusNode('entryNumber');
                }

                if (e.code === 'Escape') {
                  e.preventDefault();
                  handleKeyDown(e);
                }
              }}
              disabledDate={(current) => {
                if (isOrder) {
                  return current.isAfter(app?.financialEndYear);
                }
                if (isSales && salesOrderDateAD) {
                  return (
                    current.isBefore(dayjs(salesOrderDateAD), 'day') ||
                    current.isAfter(app?.financialEndYear)
                  );
                }
                return (
                  current.isBefore(app?.financialStartYear, 'day') ||
                  current.isAfter(app?.financialEndYear)
                );
              }}
              disabled={selectedData?.isCancel}
            />
          </Form.Item>
        </Col>
        {isSalesOrder || isSalesQuotation ? (
          <Col
            xs={dateType === 'ad' ? 0 : 24}
            md={dateType === 'ad' ? 0 : 12}
            lg={dateType === 'ad' ? 0 : 4}
          >
            <NewNepaliDatePicker
              allowClear={false}
              formProps={{
                name: 'entry_date_bs',
                label: isSalesOrder ? 'Order Date(BS)' : 'Entry Date (BS)',
                initialValue: getTodayDate(),
                hidden: dateType === 'ad',
                rules: [
                  {
                    required: true,
                    message: '',
                  },
                ],
              }}
              disabledBefore={
                isSalesOrder ? undefined : getBsFromAD(app?.financialStartYear)
              }
              disabledAfter={getBsFromAD(app?.financialEndYear)}
              ref={nepaliDateRef}
              selectRef={selectRef}
              onChange={(e) => {
                if (!e) return;
                if (e > getTodayDate() && isSales) {
                  formD.setFieldsValue({ entry_date_bs: getTodayDate() });
                  return;
                }
                const adDate = getAdFromBS(e);
                formD.setFieldsValue({ entryDate: adDate });
                setSelectedData((prev) => ({
                  ...prev,
                  entryDate: adDate,
                }));
                hanldeInputData('entryDate', adDate);
              }}
              onKeyDown={(e) => {
                if (e.code === 'Enter' || e.code === 'NumpadEnter') {
                  e.preventDefault();
                  if (isStock) {
                    selectRefs.current[
                      selectRefs?.current?.length - 1
                    ]?.current?.focus();
                  } else if (!isOrder) {
                    selectRef.current?.focus();
                  } else if (isOrder) {
                    if (dateType === 'ad') {
                      focusNode('deliveryDate');
                    }
                  }
                }
                if (e.code === 'ArrowUp') {
                  e.preventDefault();
                  focusNode('entryNumber');
                }

                if (e.code === 'Escape') {
                  e.preventDefault();
                  handleKeyDown(e);
                }
              }}
            />
          </Col>
        ) : (
          <Col
            xs={dateType === 'ad' ? 0 : 24}
            md={dateType === 'ad' ? 0 : 12}
            lg={dateType === 'ad' ? 0 : 4}
          >
            <NewNepaliDatePicker
              allowClear={false}
              formProps={{
                name: 'entry_date_bs',
                label: isSalesOrder ? 'Order Date' : 'Entry Date',
                initialValue: getTodayDate(),
                hidden: dateType === 'ad',
                rules: [
                  {
                    required: true,
                    message: '',
                  },
                ],
              }}
              disabledBefore={
                isSales && salesOrderDateBs
                  ? salesOrderDateBs
                  : getBsFromAD(app?.financialStartYear)
              }
              // disabledAfter={getTodayDate()}
              disabledAfter={getBsFromAD(app?.financialEndYear)}
              disabled={selectedData?.isCancel}
              // disabled={
              //   from === 'sales' ||
              //   from === 'sales-order' ||
              //   from === 'order' ||
              //   from === 'salesagent'
              // }
              ref={nepaliDateRef}
              selectRef={isOrder ? null : selectRef}
              onChange={(e) => {
                if (!e) return;
                if (e > getTodayDate() && isSales) {
                  // formD.setFieldsValue({ entry_date_bs: getTodayDate() });
                  // return;
                }
                const adDate = getAdFromBS(e);
                formD.setFieldsValue({ entryDate: adDate });
                setSelectedData((prev) => ({
                  ...prev,
                  entryDate: adDate,
                }));
                hanldeInputData('entryDate', adDate);
              }}
              onKeyDown={(e) => {
                if (e.code === 'Enter' || e.code === 'NumpadEnter') {
                  e.preventDefault();
                  if (isStock) {
                    selectRefs.current[
                      selectRefs?.current?.length - 1
                    ]?.current?.focus();
                  } else if (!isOrder) {
                    selectRef.current?.focus();
                  } else if (isOrder) {
                    if (dateType === 'ad') {
                      focusNode('deliveryDate');
                    } else if (dateType === 'bs') {
                      deliveryDateNepaliRef?.current?.focus();
                    }
                  }
                }
                if (e.code === 'ArrowUp') {
                  e.preventDefault();
                  focusNode('entryNumber');
                }

                if (e.code === 'Escape') {
                  e.preventDefault();
                  handleKeyDown(e);
                }
              }}
            />
          </Col>
        )}

        {from === 'order' ? (
          <Col
            xs={dateType === 'ad' ? 24 : 0}
            md={dateType === 'ad' ? 12 : 0}
            lg={dateType === 'ad' ? 4 : 0}
          >
            <Form.Item
              name="deliveryDate"
              label="Delivery Date:"
              className="username"
              rules={[{ required: true, message: '' }]}
            >
              <DatePicker
                style={{ width: '100%' }}
                className="date-picker"
                allowClear={false}
                format="YYYY-MM-DD"
                // disabledDate={(current) =>
                //   editReferenceId ? '' : dateDisabled(orderDataAD, 'before')
                // }
                disabledDate={(current) => {
                  return current && current.isBefore(orderDataAD, 'day');
                }}
                onKeyDown={(e) => {
                  if (e.code === 'Enter' || e.code === 'NumpadEnter') {
                    e.preventDefault();
                    selectRef?.current?.focus();
                  } else if (e.code === 'ArrowUp' && isOrder) {
                    e.preventDefault();
                    focusNode('entryDate');
                  } else if (e.code === 'Escape') {
                    e.preventDefault();
                    handleKeyDown(e);
                  }
                }}
                onChange={(date) => hanldeInputData('deliveryDate', date)}
              />
            </Form.Item>
          </Col>
        ) : (
          <div></div>
        )}
        {from === 'order' ? (
          <Col
            xs={dateType === 'bs' ? 24 : 0}
            md={dateType === 'bs' ? 12 : 0}
            lg={dateType === 'bs' ? 4 : 0}
          >
            <NewNepaliDatePicker
              formProps={{
                name: 'deliveryDate_bs',
                label: 'Delivery Date',
                initialValue: getTodayDate(),
                hidden: dateType === 'ad',
                rules: [
                  {
                    required: true,
                    message: '',
                  },
                ],
              }}
              disabledBefore={
                orderDataBs ||
                formD?.getFieldValue('entry_date_bs') ||
                getTodayDate()
              }
              ref={deliveryDateNepaliRef}
              selectRef={selectRef}
              onChange={(e) => {
                if (!e) return;
                // if (e > getTodayDate()) {
                // formD.setFieldsValue({ deliveryDate_bs: getTodayDate() });
                // return;
                // }
                const adDate = getAdFromBS(e);
                if (adDate) {
                  formD.setFieldsValue({ deliveryDate: adDate });
                  hanldeInputData('deliveryDate', adDate);
                }
              }}
              onKeyDown={(e) => {
                if (e.code === 'Enter' || e.code === 'NumpadEnter') {
                  e.preventDefault();
                  if (isOrder) {
                    focusNode('deliveryDate');
                  }
                }
                if (e.code === 'ArrowUp') {
                  e.preventDefault();
                  focusNode('entryNumber');
                }

                if (e.code === 'Escape') {
                  e.preventDefault();
                  handleKeyDown(e);
                }
              }}
            />
          </Col>
        ) : (
          <div></div>
        )}
      </Row>

      <Row
        style={{
          paddingLeft: !noPadding ? '15px' : undefined,
          paddingRight: !noPadding ? '15px' : undefined,
        }}
        gutter={[16, 16]}
        justify="space-between"
      >
        <Col
          xs={24}
          md={12}
          lg={hasStores ? (isSales ? 7 : 8) : isSales ? 10 : 12}
        >
          <Form.Item
            label="Party Name"
            name="ledger"
            className="username"
            rules={[
              {
                required: from === 'stock' ? false : true,
                message: '',
              },
            ]}
          >
            {from === 'stock' ? (
              <Select
                virtual={false}
                disabled={from === 'stock'}
                onKeyDown={(e) => {
                  if (e.code === 'Escape') {
                    e.preventDefault();
                    handleKeyDown(e);
                  }
                }}
              >
                {showPartyList?.map((partyName) => (
                  <Select.Option value={partyName?.referenceId}>
                    {partyName?.name}
                  </Select.Option>
                ))}
              </Select>
            ) : (
              <CustomSelect
                style={{ width: '' }}
                onChange={(value, option) => {
                  hanldeInputData('ledger', value, option?.ledgerName);
                  // Visual order: Party Name → Store → Agent → table
                  if (hasStores) {
                    focusNode('storeId');
                  } else if (from === 'salesagent' || from === 'order') {
                    agentRef?.current?.focus();
                  } else {
                    selectRefs.current[0]?.current?.focus();
                  }
                }}
                onSelect={(value, option) => {
                  hanldeInputData('ledger', value, option?.ledgerName);
                  if (hasStores) {
                    focusNode('storeId');
                  } else if (from === 'salesagent' || from === 'order') {
                    agentRef?.current?.focus();
                  } else {
                    selectRefs.current[
                      selectRefs?.current?.length - 1
                    ]?.current?.focus();
                  }
                }}
                loading={partyLoading}
                onKeyDown={(e) => {
                  if (e.code === 'ArrowLeft') {
                    e.preventDefault();
                    focusNode('entryDate');
                  }
                  if (
                    e.key === '+' ||
                    e.code === 'Equal' ||
                    e.code === 'NumpadAdd'
                  ) {
                    e.preventDefault();
                    handleAddClick();
                  }

                  if (e.code === 'Escape') {
                    handleKeyDown(e);
                  }
                }}
                virtual={false}
                {...(onPartySearch && {
                  onSearch: onPartySearch,
                  onPopupScroll: onPartyPopupScroll,
                  onDropdownVisibleChange: onPartyOpenChange,
                  filterOption: false,
                  filterSort: () => 0,
                  notFoundContent: partyLoading ? (
                    <Spin size="small" />
                  ) : undefined,
                })}
                selectRef={selectRef}
                options={partyListArray}
                onAddClick={handleAddClick}
                onClear={() => {
                  hanldeInputData('ledger', '');
                }}
                disabled={
                  from === 'sales' ||
                  from === 'sales-order' ||
                  from === 'quickpurchase' ||
                  from === 'sales-edit' ||
                  selectedData?.isCancel
                }
              />
            )}
          </Form.Item>
        </Col>

        {hasStores && (
          <Col xs={24} md={12} lg={4}>
            <Form.Item
              label="Store"
              name="storeId"
              className="username"
              rules={[{ required: false, message: '' }]}
            >
              <Select
                placeholder="Select Store"
                allowClear
                disabled={selectedData?.isCancel}
                onKeyDown={(e) => {
                  if (e.code === 'Escape') {
                    e.preventDefault();
                    handleKeyDown(e);
                  }
                  if (e.code === 'Enter' || e.code === 'NumpadEnter') {
                    setTimeout(() => {
                      if (from === 'salesagent' || from === 'order') {
                        agentRef?.current?.focus();
                      } else {
                        selectRefs?.current?.[0]?.current?.focus();
                      }
                    }, 0);
                  }
                }}
                onChange={async (value) => {
                  hanldeInputData('storeId', value);
                  const billNumberField = isFromQuickPurchase
                    ? 'purchaseBillNumber'
                    : 'billNumber';
                  let nextFormatId = null;
                  if (hasBillFormat) {
                    const nextFormatList = getBillFormatList(
                      app?.stores,
                      value,
                      formatTransactionType,
                    );
                    nextFormatId = nextFormatList[0]?.billFormatId ?? null;
                    setBillFormatList(nextFormatList);
                    setBillFormatId(nextFormatId);
                    formInstance?.setFieldsValue({ billFormat: nextFormatId });
                    if (!nextFormatId) {
                      // The old number belongs to the old store + format, and
                      // no new one is fetched until a format is picked.
                      hanldeInputData(billNumberField, null);
                      formInstance?.setFieldsValue({
                        [billNumberField]: null,
                      });
                    }
                  }
                  const canFetchBillNumber = hasBillFormat
                    ? Boolean(value && nextFormatId)
                    : true;
                  if (storeBillNumberBase && canFetchBillNumber) {
                    const billParams = new URLSearchParams();
                    if (value) billParams.append('storeId', value);
                    if (nextFormatId)
                      billParams.append('billFormatId', nextFormatId);
                    const billQuery = billParams.toString();
                    const response = await getBillData({
                      url: billQuery
                        ? `${storeBillNumberBase}?${billQuery}`
                        : storeBillNumberBase,
                    });
                    hanldeInputData(billNumberField, response?.billNumber);
                  }
                  if (from === 'salesagent' || from === 'order') {
                    agentRef?.current?.focus();
                  } else {
                    selectRefs?.current?.[0]?.current?.focus();
                  }
                }}
                onSelect={() => {
                  if (from === 'salesagent' || from === 'order') {
                    agentRef?.current?.focus();
                  } else {
                    selectRefs?.current?.[0]?.current?.focus();
                  }
                }}
                options={app.stores.map((store) => ({
                  value: store.referenceId,
                  label: store.name,
                }))}
              />
            </Form.Item>
          </Col>
        )}

        {from === 'salesagent' || from === 'order' ? (
          <>
            <Col
              xs={24}
              md={12}
              lg={hasStores ? (isSales ? 7 : 10) : isSales ? 8 : 10}
            >
              <Form.Item
                label="Agent Name"
                name="agentId"
                className="username"
                rules={[
                  {
                    required: false,
                    message: '',
                  },
                ]}
              >
                <CustomSelect
                  style={{ width: '' }}
                  onChange={(value, option) => {
                    hanldeInputData('agentId', value, option?.label);
                    if (from === 'salesagent' || isOrder) {
                      selectRefs.current[0]?.current?.focus();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.code === 'Escape') {
                      handleKeyDown(e);
                    }
                  }}
                  selectRef={agentRef}
                  loading={agentLoading}
                  {...(onAgentSearch && {
                    onSearch: onAgentSearch,
                    onPopupScroll: onAgentPopupScroll,
                    onDropdownVisibleChange: onAgentOpenChange,
                    filterOption: false,
                    filterSort: () => 0,
                    notFoundContent: agentLoading ? (
                      <Spin size="small" />
                    ) : undefined,
                  })}
                  options={agentList?.map((partyName) => ({
                    key: partyName.referenceId,
                    value: partyName.referenceId,
                    label: partyName.name,
                  }))}
                  // onAddClick={handleAddClick}
                  onAddClickSalesAgent={handleAddClickSalesAgent}
                  disabled={selectedData?.isCancel}

                  // onAddClick
                />
              </Form.Item>
            </Col>

            {/* Order Date — only for salesagent (isSales) */}
            {isSales && (
              <Col
                xs={dateType === 'bs' ? 0 : 24}
                md={dateType === 'bs' ? 0 : 12}
                lg={dateType === 'bs' ? 0 : 4}
              >
                <Form.Item
                  name="orderDate"
                  label="Order Date"
                  className="username"
                  hidden={dateType === 'bs'}
                >
                  <DatePicker
                    style={{ width: '100%' }}
                    className="date-picker"
                    format="YYYY-MM-DD"
                    allowClear={false}
                    onChange={(date) => {
                      hanldeInputData('orderDate', date);
                      if (date) {
                        formD.setFieldsValue({
                          order_date_bs: getBsFromAD(date),
                        });
                      }
                    }}
                    disabledDate={(current) =>
                      current.isAfter(app?.financialEndYear)
                    }
                    disabled={selectedData?.isCancel}
                  />
                </Form.Item>
              </Col>
            )}
            {isSales && (
              <Col
                xs={dateType === 'ad' ? 0 : 24}
                md={dateType === 'ad' ? 0 : 12}
                lg={dateType === 'ad' ? 0 : 4}
              >
                <NewNepaliDatePicker
                  allowClear={false}
                  formProps={{
                    name: 'order_date_bs',
                    label: 'Order Date',
                    initialValue: getTodayDate(),
                    hidden: dateType === 'ad',
                  }}
                  disabledBefore={undefined}
                  disabledAfter={getBsFromAD(app?.financialEndYear)}
                  ref={orderDateNepaliRef}
                  onChange={(e) => {
                    if (!e) return;
                    const adDate = getAdFromBS(e);
                    formD.setFieldsValue({ orderDate: adDate });
                    hanldeInputData('orderDate', adDate);
                  }}
                  disabled={selectedData?.isCancel}
                />
              </Col>
            )}

            <Col xs={24} md={12} lg={2}>
              <Button
                type={'dashed'}
                color="default"
                variant="outlined"
                onClick={() => {
                  setFilterVisible(true);
                }}
                disabled={selectedData?.isCancel}
              >
                Filter <FilterOutlined className="tw-ms-1 tw-text-lg" />
              </Button>
            </Col>
          </>
        ) : (
          <div></div>
        )}
      </Row>

      <Drawer
        open={filterVisible}
        setOpen={() => {}}
        width={'30%'}
        onClose={() => {
          setFilterVisible(false);
        }}
        title={<div>{'Apply Filter'}</div>}
        footer={null}
      >
        <div className="tw-grid md:tw-grid-cols-1 tw-gap-2">
          <Form.Item
            className="username"
            label="Group"
            name="groupIds"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Tooltip
              placement="bottomLeft"
              title={groupData?.data
                ?.filter((group) => groupIds.includes(group.referenceId))
                .map((group) => group.name)
                .join(', ')}
            >
              <CustomSelect
                mode="multiple"
                value={groupIds}
                style={{ width: '100%' }}
                placeholder="Select inventory Group for Filter"
                onChange={(values) => {
                  setGroupIds(values);
                }}
                options={groupData?.data?.map((item) => ({
                  value: item.referenceId,
                  label: item.name,
                }))}
                showAddButton={false}
              />
            </Tooltip>
          </Form.Item>

          <Form.Item
            className="username"
            label="Category"
            name="categoryIds"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Tooltip
              placement="bottomLeft"
              title={subGroupData?.data
                ?.filter((group) => categoryIds.includes(group.referenceId))
                .map((group) => group.name)
                .join(', ')}
            >
              <CustomSelect
                mode="multiple"
                style={{ width: '100%' }}
                value={categoryIds}
                placeholder="Select category for filter"
                onChange={(values) => {
                  setCategoryIds(values);
                }}
                options={subGroupData?.data?.map((item) => ({
                  value: item.referenceId,
                  label: item.name,
                }))}
                showAddButton={false}
              />
            </Tooltip>
          </Form.Item>
          {/* <div>
            <AntButton
              color="yellow"
              icon={<ClearOutlined />}
              iconPosition="end"
              onClick={() => {}}
            >
              Reset
            </AntButton>
          </div> */}
        </div>
      </Drawer>

      <GlobalFormModal
        title="Create Ledger"
        isVisible={isModalVisible}
        onClose={() => {
          closeModal();
          selectRef.current?.focus?.();
        }}
      >
        <LedgerForm
          isSalesAgent={isSalesAgent}
          onClose={() => {
            selectRef.current?.focus?.();
            closeModal();
          }}
          refreshTable={refreshTable}
        />
      </GlobalFormModal>
    </>
  );
};

export default DynamicTransactionHeader;
